export default __webpack_public_path__ + "static/media/Background 5_00024.31898c5e.png";